export { default } from './DefaultResultsPage';
